export default {"src":"/_next/static/media/competitiveExchangeRates.bcbfd402.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};